<script setup>
// Notification outlet for the Sites dashboard (`Utils/siteToast.js`): the same
// look as the global toasts, plus an optional router link in `item.data.link`
// (e.g. "Open Plans" after a plan was left without content).
</script>

<template>
	<notifications group="sites" position="top right" style="top:10px;right:10px" :speed="300">
		<template #body="{ item, close }">
			<div class="vue-notification-template vue-notification !pr-8" :class="item.type || 'info'" role="status" data-testid="site-toast" :data-type="item.type || 'info'">
				<span>{{ item.text }}</span>
				<router-link v-if="item.data?.link" :to="item.data.link.to" class="ml-1.5 font-medium text-main-light underline underline-offset-2 hover:text-white" data-testid="site-toast-link" @click="close">
					{{ item.data.link.label }}
				</router-link>
				<button type="button" class="absolute right-2 top-2 text-surface-7 hover:text-white" aria-label="Dismiss" @click="close">×</button>
			</div>
		</template>
	</notifications>
</template>
